import {customAxiosBE} from "../config";

export async function getPrices(data) {
    return customAxiosBE.post(`/getPrices`,data)
}
